import { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useHistory, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { DefaultTheme, useTheme } from 'styled-components';
import Swal from 'sweetalert2';
import { Breadcrumb } from '../../components/Breadcrumb';
import { Button } from '../../components/Button';
import api from '../../services/api';
import { IClient } from '../../interfaces/IClient';
import { IPagination, Pagination } from '../../components/Pagination';
import { ItemWithThumb } from '../../components/ItemWithThumb';

export const Clients = () => {
  const location = useLocation();
  const history = useHistory();
  const theme: DefaultTheme = useTheme();
  const [clients, setClients] = useState<IClient[]>([]);
  const [pagination, setPagination] = useState<IPagination>();

  useEffect(() => {
    api
      .get(`/clients/${location.search}`)
      .then(({ data }) => {
        setClients(data.data);
        setPagination({
          currentPage: data.meta.current_page,
          perPage: data.meta.per_page,
          total: data.meta.total,
        });
      })
      .catch(() => toast.error('Erro ao buscar clientes'));
  }, [location.search]);

  const handleRemoveClient = (idClient: number) => {
    Swal.fire({
      title: `<h4 style="color: ${theme.colors.textSecondary}">Você tem certeza disso? Ao excluir um cliente, você também excluirá todos os usuários vinculados a ele.</h4>`,
      icon: 'error',
      showCancelButton: true,
      confirmButtonColor: theme.colors.secondary,
      cancelButtonColor: theme.colors.textSecondary,
      cancelButtonText: 'Fechar',
      confirmButtonText: 'Sim, apagar!',
    }).then(async result => {
      if (result.isConfirmed) {
        try {
          await api.delete(`clients/${idClient}`);
          setClients(old => [...old.filter(item => item.id !== idClient)]);
          toast.success('Cliente excluído com sucesso');
        } catch {
          toast.error('Erro ao excluir cliente');
        }
      }
    });
  };

  return (
    <>
      <Breadcrumb
        items={[
          {
            title: 'Clientes',
          },
        ]}
      />
      <Row className="d-flex align-items-center mt-4">
        <Col md={10} xs={9}>
          <h3>Gerenciar clientes</h3>
        </Col>
        <Col md={2} xs={{ span: 3 }}>
          <Button
            type="button"
            background={theme.colors.secondary}
            color="#fff"
            onClick={() => history.push('/clients/new')}
          >
            Novo
          </Button>
        </Col>
      </Row>

      <Row className="mt-2">
        {clients.map(item => (
          <Col md={4} key={item.id}>
            <ItemWithThumb
              name={item.name}
              urlImage={item.logo}
              urlRedirect={`/clients/${item.id}`}
              id={item.id}
              onRemoveItem={handleRemoveClient}
            />
          </Col>
        ))}
        <Col md={12}>{pagination && <Pagination {...pagination} />}</Col>
      </Row>
    </>
  );
};
